module.exports = __webpack_public_path__ + "media/story_video.7e11022c.mp4";